import {ObjectResizer, IConfig} from './ObjectResizer';

declare const THREE: any;

export class WallResizer extends ObjectResizer {

  private static saveChildrenPosition(wall) {
    const positions = [];
    const position = new THREE.Vector3();
    wall.updateMatrixWorld();
    wall.children.forEach(ch => {
      position.copy(ch.position);
      wall.localToWorld(position);
      positions.push(position.clone());
    });
    return positions;
  }

  private static restoreChildrenPosition(wall, positions) {
    wall.updateMatrixWorld();
    wall.children.forEach((child, i) => {
      const position = positions[i];
      wall.worldToLocal(position);
      child.position.copy(position);
    });
  }

  resize(config: IConfig) {
    const {object: wall} = config;
    const positions = WallResizer.saveChildrenPosition(wall);
    super.resize(config);
    WallResizer.restoreChildrenPosition(wall, positions);
  }

}




// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/WallResizer.ts